import React from 'react';
import PropTypes from 'prop-types';

import Loading from 'components/Loading';

export default function ListWrapper({className = '', list, loading = <Loading/>, mapFn, placeholder = null}) {
    let children;
    if (list) {
        children = list.length ? list.map(mapFn) : placeholder;
    } else {
        children = loading;
    }

    return (
        <div className={className}>{children}</div>
    );
}

ListWrapper.propTypes = {
    className: PropTypes.string,
    list: PropTypes.array,
    mapFn: PropTypes.func,
    loading: PropTypes.element,
    placeholder: PropTypes.element
};


// WEBPACK FOOTER //
// ./src/components/common/ListWrapper.js